import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import {
	AdminAccessRequestsListResponse,
	AdminAccessRequestsService,
} from '../../api/admin-access-requests.service';

@Component({
	selector: 'of-admin-access-requests-page',
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatCardModule, MatProgressBarModule],
	template: `
		<div class="page">
			<mat-card class="card" *ngIf="vm$ | async as vm; else loading">
				<h2>Admin · Access Requests</h2>
				<p class="muted">Approve or deny workspace access. Role changes live under Admin · Users.</p>

				<div class="actions" style="justify-content: flex-end;">
					<button mat-button (click)="refresh()">Refresh</button>
				</div>

				<ng-container *ngIf="vm.users.length > 0; else empty">
					<div *ngFor="let u of vm.users" style="padding: 12px 0; border-top: 1px solid rgba(255,255,255,0.08);">
						<div style="display: flex; gap: 12px; align-items: center;">
							<div style="min-width: 0; flex: 1 1 auto;">
								<div style="font-weight: 600;">{{ u.email ?? '(no email)' }}</div>
								<div class="muted" style="font-size: 13px;">
									{{ u.name ?? '—' }} · {{ u.approvalStatus }}
								</div>
							</div>

							<div class="actions" style="margin: 0;">
								<button
									mat-flat-button
									color="primary"
									(click)="approve(u.id)"
								>
									Approve
								</button>
								<button mat-button (click)="deny(u.id)">Deny</button>
							</div>
						</div>
					</div>
				</ng-container>

				<ng-template #empty>
					<p class="muted">No pending requests.</p>
				</ng-template>
			</mat-card>
		</div>

		<ng-template #loading>
			<div class="page">
				<mat-card class="card">
					<mat-progress-bar mode="indeterminate"></mat-progress-bar>
				</mat-card>
			</div>
		</ng-template>
	`,
})
export class AdminAccessRequestsPage {
	private readonly refresh$ = new BehaviorSubject<void>(undefined);
	vm$: Observable<AdminAccessRequestsListResponse>;

	constructor(private readonly admin: AdminAccessRequestsService) {
		this.vm$ = this.refresh$.pipe(switchMap(() => this.admin.list()));
	}

	refresh() {
		this.refresh$.next();
	}

	approve(userId: string) {
		this.admin.approve(userId).subscribe({
			next: () => this.refresh(),
			error: () => this.refresh(),
		});
	}

	deny(userId: string) {
		this.admin.deny(userId).subscribe({
			next: () => this.refresh(),
			error: () => this.refresh(),
		});
	}
}
